(function (app, ng) {

    app.component("addToCalendar",
        {
            templateUrl: "/App/Components/AddToCalendar/addtocalendar.html",
            controller: addToCalendarController,
            controllerAs: "addtocalendar",
            bindings: {
                startDate: "@",
                endDate: "@",
                title: "@",
                description: "<",
                location: "@"
            }
        });

    addToCalendarController.$inject = ["moment", "$timeout", "$rootScope", "calendarsService"];
    function addToCalendarController(moment, $timeout, $rootScope, calendarsService) {
        var $ctrl = this;

        ng.extend($ctrl, {
            dates: {},
        });

        $ctrl.$onInit = () => {
            initializeData();
        }

        $rootScope.$on("calendarEventUpdated",
            function () {
                initializeData();
            });

        this.$onChanges = function (changes) {
            if (changes.description) {
                this.description = changes.description.currentValue;
                initializeData();
            }
        }

        function setTimesFromFormat() {
            ["startDate", "endDate"].forEach(function (key) {
                var dt = moment($ctrl[key]);
                $ctrl.dates[key] = dt.format("YYYYMMDDTHHmmss");
            });
        }

        function getSanitizedData() {
            var urlData = {};
            var bindings = {
                startDate: "@",
                endDate: "@",
                title: "@",
                description: "<",
                location: "@"
            }

            Object.keys(bindings).forEach(function (key) {
                urlData[key] = encodeURIComponent($ctrl[key] || "");
            });

            return urlData;
        }

        function buildUrl() {
            var urlData = ng.extend(getSanitizedData(), $ctrl.dates),
                icsData = ng.extend({}, $ctrl, $ctrl.dates);

            $ctrl.calendarUrl = {
                microsoft: calendarsService.getMicrosoftCalendarUrl(urlData),
                google: calendarsService.getGoogleCalendarUrl(urlData),
                yahoo: calendarsService.getYahooCalendarUrl(urlData),
                icalendar: calendarsService.getIcsCalendar(icsData),
                dlIcal: dlIcal.bind(this)
            };
        }

        function dlIcal() {
            var fileName = $ctrl.title.replace(/[^\w ]+/g, "") + ".ics",
                icsData = $ctrl.calendarUrl.icalendar,
                icsBlob = new Blob([icsData], { type: "application/octet-stream" });

            var file = document.createElement("a");
            document.body.appendChild(file);
            file.style = "display:none";

            var url = window.URL.createObjectURL(icsBlob);
            file.href = url;
            file.download = fileName;
            file.click();

            $timeout(function () {
                document.body.removeChild(file);
                window.URL.revokeObjectURL(url);
            },
                100);
        }

        function initializeData() {
            setTimesFromFormat();
            buildUrl();
        }
    }

})(window.app, window.angular); //jshint ignore:line